





























































import { Component, Vue } from 'vue-property-decorator';
import WithdrawTips from '@/components/WithdrawTips.vue';
import DialogWithdraw from '@/components/DialogWithdraw.vue';

@Component({
    components: {
        WithdrawTips,
        DialogWithdraw,
    }
})
export default class Withdraw extends Vue{
    dialogShow: boolean = false;
    
    amount: number = 0;
    amountArr: number[] = [100, 500, 100];
    phone: string = "";
    fromVal: string = "";

    configIdx: number = 0;
    amountIdx: number = 0;
    phoneNumber: string = '';
    phoneErr: string = '';
    phoneNumber2: string = '';
    phoneErr2: string = '';
    countryCode: string = '91';
    
    // 是否提现过
    hasWithdraw: boolean = false;
    get configData() {
        return this.$store.state.withdrawData;
    };

    mounted() {
        this.getConfigData();
    }

    getConfigData() {
        // console.log('withdraw data ====== ', this.$store.state);
        
        if(this.configData.length > 0) {
            if(this.configData[0].phone.value) {
                this.hasWithdraw = true;
                this.phoneNumber = this.configData[0].phone.value
                this.phoneNumber2 = this.configData[0].phone.value
            }else{
                this.hasWithdraw = false;
            }

            this.amountArr = this.configData[0].amount;
            
        }else{
            this.amountArr = [100, 500, 1000];
        }
        
    }

    // 渠道选择
    selectItem(idx: number) {
        let self = this;

        this.$as.send('select_qudao_Withdraw');
        self.configIdx = idx;
        self.countryCode = self.configData[self.configIdx] ? self.configData[self.configIdx].country.value : '91';
        self.amountArr = self.configData[self.configIdx].amount;
    }

    // 金额选择
    selectAmount(idx: number) {
        this.$as.send('select_amount_Withdraw');
        this.amountIdx = idx;
    }

    // 验证手机号
    verifyPhone() {
        let self = this;
        let reg = new RegExp(self.configData[self.configIdx].phone.pattern);
        let res = false;

        res = reg.test(self.phoneNumber)
        if(res) {
            self.phoneErr = '';
        }else{
            self.phoneErr = 'Mobile number verification failed';
        }

        return res;
    }

    verifyPhone2() {
        let self = this;
        let reg = new RegExp(self.configData[self.configIdx].phone.pattern);
        let res = false;

        
        if(reg.test(self.phoneNumber2)) {
            if(self.phoneNumber === self.phoneNumber2) {
                res = true;
                self.phoneErr2 = '';
            }else{
                self.phoneErr2 = 'Mobile number not consistent';
            }
        }else{
            self.phoneErr2 = 'Mobile number verification failed';
        }

        return res;
    }

    // click ok button 
    clickOK() {
        let self = this;

        this.$as.send('select_withdraw_btn_Withdraw');
        if(self.verifyPhone() && self.verifyPhone2()) {
            self.amount = self.configData[self.configIdx].amount[self.amountIdx]
            self.phone = self.phoneNumber;
            self.fromVal = self.configData[self.configIdx].name;

            self.dialogShow = true;
        }
    }

    // 显示/隐藏 对话框
    showDialog(flag: boolean, evt: any) {
        this.dialogShow = flag;
    }
}
